/**
 * Created by razial on 28.10.2025.
 */

Reward.register("unit", {
    parse: function (value, options) {
        return RewardTypes.units.parse(value, options);
    }
});

Reward.register("energyBooster", {
    ...Reward.TimeValue,
    controls: "MenuBarLivesItem",
    target: "energy",

    getIcon: function () {
        return bundles.reward_icons.frames.energy_booster_png;
    },

    getSmallIcon: function () {
        return bundles.reward_icons.frames.energy_booster_png;
    },

    receive: function (value) {
        const time = typeof value.time === "string" ? cleverapps.parseInterval(value.time) : value.time;
        cleverapps.metrics.logEvent(`${cleverapps.EVENTS.BOOSTER_RECEIVE}-energy`, {
            itemId: this.options.event || cleverapps.EVENTS.EARN.OTHER,
            value: Math.round(time / cleverapps.parseInterval("1 minute"))
        });
        cleverapps.playSession.logEventOnce(`${cleverapps.EVENTS.BOOSTER_RECEIVE_DAU}-energy`);

        cleverapps.energyBooster.activate(time);
        return function () {};
    }
});

// value: { code, stage, amount, pointsValue, customInfo }
Reward.register("units", {
    countable: true,
    getIcon: function (value, options) {
        options = options || {};
        const icon = options.unitViewDummy ? new cc.Sprite(bundles.windows.frames.big_prize_png) : UnitView.getUnitImage(value, { alignAnchorX: true, preferStatic: true, customStatic: true });
        cleverapps.UI.fitToBox(icon, cleverapps.styles.Reward.icon);
        return icon;
    },

    getAmount: function (value) {
        return value.amount || 1;
    },

    getText: function (value, prefix) {
        return this.getPrefix(prefix) + (value.pointsValue || value.amount || 1);
    },

    getTarget: function (value, options) {
        if (options.toBubbleStack && typeof BubblesStack !== "undefined") {
            return BubblesStack.ID;
        }
        if (options.toMainWorld) {
            return "mainWorld";
        }
        return "units";
    },

    getPrice: function (value) {
        const prices = LinePrices[value.code] || [];
        return (prices[value.stage] || 0) * this.getAmount(value);
    },

    isBigReward: function (value) {
        return value.code === "coinsplant" || value.code === "rubiesplant" || value.code === "magicplant" && value.stage === 5;
    },

    sumValues: function (value, other) {
        return cleverapps.toArray(other || []).concat(cleverapps.toArray(value));
    },

    parse: function (value, options) {
        return cleverapps.toArray(value).map((unit) => new Reward("units", unit, options));
    },

    receive: function (value) {
        if (Unit.isBooster(value.code)) {
            const amount = value.amount || 1;
            cleverapps.metrics.logEvent(`${cleverapps.EVENTS.BOOSTER_RECEIVE}-${value.code}`, {
                itemId: this.options.event || cleverapps.EVENTS.EARN.OTHER,
                value: amount,
                counter: amount
            });
            cleverapps.playSession.logEventOnce(`${cleverapps.EVENTS.BOOSTER_RECEIVE_DAU}-${value.code}`);
        }

        const centerCell = Merge2.current.field.getScreenCenterCell();
        const units = [];

        for (let i = value.amount || 1; i > 0; --i) {
            const unit = {
                code: value.code,
                stage: value.stage,
                pointsValue: value.pointsValue,
                ...value.customInfo
            };

            units.push(unit);
        }

        let bubbleStackUsed = false;
        const spawnedUnits = [];

        units.forEach((unit) => {
            const slot = Merge2.current.field.findEmptySlot(centerCell.x, centerCell.y, unit);
            if (!slot || this.options.toBubbleStack) {
                Merge2.current.bubblesStack.push(unit, true);
                bubbleStackUsed = true;
                return;
            }

            unit = new Unit(unit);
            unit.setPosition(slot.x, slot.y);
            if (this.options.waitingSpawn) {
                unit.waitingSpawn = true;
            }
            Merge2.current.field.addUnit(slot.x, slot.y, unit);
            spawnedUnits.push(unit);
        });

        if (!this.spawnedUnits) {
            this.spawnedUnits = [];
        }

        if (spawnedUnits.length) {
            this.spawnedUnits = this.spawnedUnits.concat(spawnedUnits);
        }

        return function () {
            if (bubbleStackUsed && Merge2.current) {
                Merge2.current.bubblesStack.onPush();
            }
        };
    }
});